// Fetch list

export const FETCH = 'reportVehicleProfits.FETCH'
export const FETCH_STARTED = 'reportVehicleProfits.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportVehicleProfits.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportVehicleProfits.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportVehicleProfits.FETCH_CANCELLED'

// Export

export const EXPORT = 'reportVehicleProfits.EXPORT'
export const EXPORT_FULFILLED = 'reportVehicleProfits.EXPORT_FULFILLED'

// Clear

export const CLEAR = 'reportVehicleProfits.CLEAR'

// Fetch details

export const FETCH_DETAILS = 'reportVehicleProfits.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportVehicleProfits.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportVehicleProfits.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportVehicleProfits.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportVehicleProfits.FETCH_DETAILS_CANCELLED'

// Export details

export const EXPORT_DETAILS = 'reportVehicleProfits.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportVehicleProfits.EXPORT_DETAILS_FULFILLED'

// Clear details

export const CLEAR_DETAILS = 'reportVehicleProfits.CLEAR_DETAILS'
